var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderCell"},[_c('el-input',{attrs:{"oninput":"value=value.replace(/[^\\d]/g,'')"},on:{"change":_vm.handleChange},model:{value:(_vm.row.sortOrder),callback:function ($$v) {_vm.$set(_vm.row, "sortOrder", $$v)},expression:"row.sortOrder"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort radius-4 cursor-pointer"},[_c('i',{staticClass:"i-sort"})])
}]

export { render, staticRenderFns }